import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExitPwa = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#F23645' rx={6} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M14.675 13.67c.232-2.7 1.62-3.803 4.657-3.803h.098c3.352 0 4.695 1.343 4.695 4.695v4.89c0 3.353-1.343 4.695-4.695 4.695h-.098c-3.015 0-4.402-1.087-4.65-3.742M19.25 17h-8.535M12.388 14.487 9.875 17l2.512 2.512'
    />
  </svg>
);
export default SvgExitPwa;
